var _disableTabForCheckboxes, _isItemDisabled, _hasCheckbox, _focusFirstEnabledMenuItem, _getItems, _updateOptionsToMenuItem, _isContainerItem, _getPreviousFocusedItem, _setPreviousFocusedItem, _onContainerFocused, _onMouseEnter, _onMouseClick, _onKeyDown, _getNextItem, _getNextEnabledItem, _focusItem, _blurItem, _markCheckbox, _returnFocus, _handleHome, _handleEnd;
function _classPrivateFieldLooseBase(receiver, privateKey) { if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) { throw new TypeError("attempted to use private field on non-instance"); } return receiver; }
var id = 0;
function _classPrivateFieldLooseKey(name) { return "__private_" + id++ + "_" + name; }
import { KEYBOARS_KEYS } from '../key-codes';
var AcessibilityNavMenuPersistentData = function NavMenuPersistentDataClass() {
  if (AcessibilityNavMenuPersistentData.singleton) {
    return AcessibilityNavMenuPersistentData.singleton;
  }
  this.previousFocusedItem = undefined;
  AcessibilityNavMenuPersistentData.singleton = this;
};
var AcessibilityNavMenu = (_disableTabForCheckboxes = /*#__PURE__*/_classPrivateFieldLooseKey("disableTabForCheckboxes"), _isItemDisabled = /*#__PURE__*/_classPrivateFieldLooseKey("isItemDisabled"), _hasCheckbox = /*#__PURE__*/_classPrivateFieldLooseKey("hasCheckbox"), _focusFirstEnabledMenuItem = /*#__PURE__*/_classPrivateFieldLooseKey("focusFirstEnabledMenuItem"), _getItems = /*#__PURE__*/_classPrivateFieldLooseKey("getItems"), _updateOptionsToMenuItem = /*#__PURE__*/_classPrivateFieldLooseKey("updateOptionsToMenuItem"), _isContainerItem = /*#__PURE__*/_classPrivateFieldLooseKey("isContainerItem"), _getPreviousFocusedItem = /*#__PURE__*/_classPrivateFieldLooseKey("getPreviousFocusedItem"), _setPreviousFocusedItem = /*#__PURE__*/_classPrivateFieldLooseKey("setPreviousFocusedItem"), _onContainerFocused = /*#__PURE__*/_classPrivateFieldLooseKey("onContainerFocused"), _onMouseEnter = /*#__PURE__*/_classPrivateFieldLooseKey("onMouseEnter"), _onMouseClick = /*#__PURE__*/_classPrivateFieldLooseKey("onMouseClick"), _onKeyDown = /*#__PURE__*/_classPrivateFieldLooseKey("onKeyDown"), _getNextItem = /*#__PURE__*/_classPrivateFieldLooseKey("getNextItem"), _getNextEnabledItem = /*#__PURE__*/_classPrivateFieldLooseKey("getNextEnabledItem"), _focusItem = /*#__PURE__*/_classPrivateFieldLooseKey("focusItem"), _blurItem = /*#__PURE__*/_classPrivateFieldLooseKey("blurItem"), _markCheckbox = /*#__PURE__*/_classPrivateFieldLooseKey("markCheckbox"), _returnFocus = /*#__PURE__*/_classPrivateFieldLooseKey("returnFocus"), _handleHome = /*#__PURE__*/_classPrivateFieldLooseKey("handleHome"), _handleEnd = /*#__PURE__*/_classPrivateFieldLooseKey("handleEnd"), function AcessibilityNavMenuClass(_menuElement) {
  var _this = this;
  this.roleContainerItemName = 'option';
  // 'menuitem'
  this.menuItens = [];
  this.menuElement = null;
  Object.defineProperty(this, _disableTabForCheckboxes, {
    writable: true,
    value: function value() {
      var checkboxes = _this.menuElement.querySelectorAll("[type=checkbox");
      checkboxes.forEach(function (checkbox) {
        checkbox.setAttribute('tabIndex', '-1');
      });
    }
  });
  this.focus = function () {
    _classPrivateFieldLooseBase(_this, _setPreviousFocusedItem)[_setPreviousFocusedItem](document.activeElement);
    _this.menuElement.focus();
  };
  Object.defineProperty(this, _isItemDisabled, {
    writable: true,
    value: function value(item) {
      var disabled = item.hasAttribute('disabled');
      return !!disabled;
    }
  });
  Object.defineProperty(this, _hasCheckbox, {
    writable: true,
    value: function value() {
      var checkbox = _this.menuElement.querySelector('[type=checkbox]');
      return !!checkbox;
    }
  });
  Object.defineProperty(this, _focusFirstEnabledMenuItem, {
    writable: true,
    value: function value() {
      if (_this.menuItens) {
        var fistItemEnabled = Array.from(_this.menuItens).find(function (item) {
          return !_classPrivateFieldLooseBase(_this, _isItemDisabled)[_isItemDisabled](item);
        });
        if (fistItemEnabled) {
          _this.menuElement.tabIndex = -1;
          fistItemEnabled.tabIndex = 0;
          fistItemEnabled.focus();
        }
      }
    }
  });
  Object.defineProperty(this, _getItems, {
    writable: true,
    value: function value(menuElement) {
      return menuElement.querySelectorAll("[role=" + _this.roleContainerItemName + "]");
    }
  });
  Object.defineProperty(this, _updateOptionsToMenuItem, {
    writable: true,
    value: function value() {
      var itens = _this.menuElement.querySelectorAll("[role=option");
      Array.from(itens).forEach(function (item) {
        item.setAttribute('role', 'menuitem');
      });
    }
  });
  Object.defineProperty(this, _isContainerItem, {
    writable: true,
    value: function value(item) {
      if (_this.doNotUseMenuItem) {
        return true;
      }
      var role = item.getAttribute('role');
      return role === _this.roleContainerItemName;
    }
  });
  this.hasChildrenMenu = function () {
    return _this.menuItens.length > 0;
  };
  this.addListeners = function () {
    _this.menuElement.addEventListener('focus', _classPrivateFieldLooseBase(_this, _onContainerFocused)[_onContainerFocused]);
    _this.menuItens.forEach(function (menuItem) {
      menuItem.addEventListener('keydown', _classPrivateFieldLooseBase(_this, _onKeyDown)[_onKeyDown]);
      menuItem.addEventListener('mouseenter', _classPrivateFieldLooseBase(_this, _onMouseEnter)[_onMouseEnter]);
      menuItem.addEventListener('click', _classPrivateFieldLooseBase(_this, _onMouseClick)[_onMouseClick]);
    });
  };
  this.removeListeners = function () {
    _this.menuElement.removeEventListener('focus', _classPrivateFieldLooseBase(_this, _onContainerFocused)[_onContainerFocused]);
    _this.menuItens.forEach(function (menuItem) {
      menuItem.removeEventListener('keydown', _classPrivateFieldLooseBase(_this, _onKeyDown)[_onKeyDown]);
      menuItem.removeEventListener('mouseenter', _classPrivateFieldLooseBase(_this, _onMouseEnter)[_onMouseEnter]);
      menuItem.removeEventListener('click', _classPrivateFieldLooseBase(_this, _onMouseClick)[_onMouseClick]);
    });
  };
  Object.defineProperty(this, _getPreviousFocusedItem, {
    writable: true,
    value: function value() {
      return _this.persistenteData.previousFocusedItem;
    }
  });
  Object.defineProperty(this, _setPreviousFocusedItem, {
    writable: true,
    value: function value(item) {
      if (!_this.menuElement.contains(item)) {
        _this.persistenteData.previousFocusedItem = item;
      }
    }
  });
  Object.defineProperty(this, _onContainerFocused, {
    writable: true,
    value: function value(event) {
      _classPrivateFieldLooseBase(_this, _focusFirstEnabledMenuItem)[_focusFirstEnabledMenuItem](event);
    }
  });
  Object.defineProperty(this, _onMouseEnter, {
    writable: true,
    value: function value(event) {
      if (event.target !== document.activeElement && !event.target.disabled) {
        var focusedItem = document.activeElement;
        if (_classPrivateFieldLooseBase(_this, _isContainerItem)[_isContainerItem](focusedItem)) {
          focusedItem.setAttribute('tabIndex', '-1');
          focusedItem.blur();
        }
        event.target.setAttribute('tabIndex', '0');
        event.target.focus();
      }
    }
  });
  Object.defineProperty(this, _onMouseClick, {
    writable: true,
    value: function value(event) {
      if (_classPrivateFieldLooseBase(_this, _hasCheckbox)[_hasCheckbox]() === false) {
        setTimeout(function () {
          _classPrivateFieldLooseBase(_this, _returnFocus)[_returnFocus](event.target);
        });
      }
    }
  });
  Object.defineProperty(this, _onKeyDown, {
    writable: true,
    value: function value(event) {
      // eslint-disable-next-line default-case
      switch (event.key) {
        case KEYBOARS_KEYS.ARROW_DOWN:
          event.preventDefault();
          _classPrivateFieldLooseBase(_this, _focusItem)[_focusItem](event.target, 'nextElementSibling');
          break;
        case KEYBOARS_KEYS.ARROW_UP:
          event.preventDefault();
          _classPrivateFieldLooseBase(_this, _focusItem)[_focusItem](event.target, 'previousElementSibling');
          break;
        case KEYBOARS_KEYS.SPACE:
        case KEYBOARS_KEYS.ENTER:
          event.preventDefault();
          _classPrivateFieldLooseBase(_this, _markCheckbox)[_markCheckbox](event.target);
          break;
        case KEYBOARS_KEYS.TAB:
          _classPrivateFieldLooseBase(_this, _blurItem)[_blurItem](event.target);
          break;
        case KEYBOARS_KEYS.ESCAPE:
          event.preventDefault();
          _classPrivateFieldLooseBase(_this, _returnFocus)[_returnFocus](event.target);
          break;
        case KEYBOARS_KEYS.HOME:
          event.preventDefault();
          _classPrivateFieldLooseBase(_this, _handleHome)[_handleHome]();
          break;
        case KEYBOARS_KEYS.END:
          event.preventDefault();
          _classPrivateFieldLooseBase(_this, _handleEnd)[_handleEnd]();
          break;
      }
    }
  });
  Object.defineProperty(this, _getNextItem, {
    writable: true,
    value: function value(item, typeFocus) {
      var index = Array.from(_this.menuItens).indexOf(item);
      var lastIndex = _this.menuItens.length - 1;
      if (typeFocus === 'nextElementSibling') {
        if (lastIndex > index) {
          return _this.menuItens[index + 1];
        }
      } else if (index > 0) {
        return _this.menuItens[index - 1];
      }
      return null;
    }
  });
  Object.defineProperty(this, _getNextEnabledItem, {
    writable: true,
    value: function value(item, typeFocus) {
      var nextItem = item;
      var disabled = true;
      var count = 0;
      var lastIndex = _this.menuItens.length;
      do {
        count += 1;
        nextItem = _classPrivateFieldLooseBase(_this, _getNextItem)[_getNextItem](nextItem, typeFocus);
        if (!nextItem) {
          disabled = false;
        } else if (nextItem === item || !_classPrivateFieldLooseBase(_this, _isContainerItem)[_isContainerItem](nextItem)) {
          disabled = true;
        } else if (nextItem) {
          disabled = _classPrivateFieldLooseBase(_this, _isItemDisabled)[_isItemDisabled](nextItem);
        } else {
          disabled = false;
        }
      } while (disabled && count < lastIndex);
      return nextItem;
    }
  });
  Object.defineProperty(this, _focusItem, {
    writable: true,
    value: function value(item, typeFocus) {
      var nextItem = _classPrivateFieldLooseBase(_this, _getNextEnabledItem)[_getNextEnabledItem](item, typeFocus);
      if (nextItem) {
        nextItem.tabIndex = 0;
        nextItem.focus();
        item.setAttribute('tabindex', '-1');
      }
    }
  });
  Object.defineProperty(this, _blurItem, {
    writable: true,
    value: function value(item) {
      setTimeout(function () {
        _this.menuElement.tabIndex = 0;
        item.setAttribute('tabindex', '-1');
        item.blur();
      });
    }
  });
  Object.defineProperty(this, _markCheckbox, {
    writable: true,
    value: function value(item) {
      var checkbox = item.querySelector('[type=checkbox]');
      if (checkbox) {
        checkbox.click();
      } else {
        item.click();
      }
    }
  });
  Object.defineProperty(this, _returnFocus, {
    writable: true,
    value: function value() {
      if (_classPrivateFieldLooseBase(_this, _getPreviousFocusedItem)[_getPreviousFocusedItem]()) {
        _classPrivateFieldLooseBase(_this, _getPreviousFocusedItem)[_getPreviousFocusedItem]().focus();
      }
    }
  });
  Object.defineProperty(this, _handleHome, {
    writable: true,
    value: function value() {
      _this.menuItens[0].focus();
    }
  });
  Object.defineProperty(this, _handleEnd, {
    writable: true,
    value: function value() {
      _this.menuItens[_this.menuItens.length - 1].focus();
    }
  });
  this.menuElement = _menuElement;
  var _role = _menuElement.getAttribute('role');
  var hasCheckbox = _classPrivateFieldLooseBase(this, _hasCheckbox)[_hasCheckbox]();
  if (hasCheckbox && !_role === 'listbox') {
    _menuElement.setAttribute('role', 'listbox');
    this.roleContainerItemName = 'option';
  } else if (_role === 'listbox') {
    this.roleContainerItemName = 'option';
  } else {
    _menuElement.setAttribute('role', 'menu');
    this.roleContainerItemName = 'menuitem';
    _classPrivateFieldLooseBase(this, _updateOptionsToMenuItem)[_updateOptionsToMenuItem]();
  }
  this.menuItens = _classPrivateFieldLooseBase(this, _getItems)[_getItems](_menuElement);
  this.persistenteData = new AcessibilityNavMenuPersistentData();
  if (hasCheckbox) {
    _classPrivateFieldLooseBase(this, _disableTabForCheckboxes)[_disableTabForCheckboxes]();
  }
});
export { AcessibilityNavMenu, AcessibilityNavMenuPersistentData };